export const ATSSwitcherIcon = (props: JSX.IntrinsicElements['svg']) => {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.15048 9.32829H0V0.5H3.16301C4.44966 0.5 5.4976 0.894398 6.30683 1.6832C7.11605 2.47199 7.52075 3.5512 7.52093 4.9208C7.52093 6.2826 7.1141 7.35771 6.30043 8.14615C5.48677 8.9346 4.43679 9.32864 3.15048 9.32829ZM1.71845 7.73426H3.08814C3.86024 7.73426 4.4954 7.4935 4.99362 7.01198C5.49183 6.53046 5.7405 5.83305 5.73961 4.91974C5.73961 4.00679 5.49094 3.30733 4.99362 2.82137C4.49629 2.33541 3.8653 2.0926 3.10066 2.09296H1.71845V7.73426Z"
        fill="white"
      />
      <path
        d="M10.9216 0.5L10.5219 6.63951H9.31395L8.91431 0.5H10.9216ZM9.22789 9.14258C9.13504 9.05205 9.06172 8.94345 9.01246 8.82349C8.9632 8.70353 8.93905 8.57474 8.94148 8.44508C8.93942 8.31456 8.96373 8.18497 9.01294 8.06406C9.06215 7.94316 9.13526 7.83343 9.22789 7.74145C9.31551 7.64778 9.42165 7.57336 9.53957 7.5229C9.65749 7.47245 9.78462 7.44707 9.91287 7.44838C10.1769 7.44909 10.4298 7.55427 10.6165 7.74093C10.8032 7.9276 10.9083 8.18056 10.909 8.44455C10.9112 8.57477 10.8862 8.70402 10.8358 8.8241C10.7853 8.94417 10.7105 9.05245 10.616 9.14205C10.524 9.23463 10.4142 9.3077 10.2933 9.35691C10.1724 9.40612 10.0428 9.43046 9.91234 9.42846C9.78484 9.42976 9.65843 9.40498 9.54086 9.35563C9.42329 9.30629 9.31706 9.23342 9.22869 9.14152L9.22789 9.14258Z"
        fill="#FEE156"
      />
    </svg>
  );
};
